import React, { useEffect, useState } from "react";
import {
  Airplay,
  ChevronLeft,
  Eye,
  Feather,
  Menu,
  Play,
  Target,
} from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { getAllAdvance, saveAdvance } from "../Service/AdvanceService";
import { getPaymentHistoryByAdvance } from "../Service/VendorAdvanceService";
import { useToast } from "../Components/toast/ToastProvider";
import { getAllVendors } from "../Service/VendorService";
import "../Style/home.css";
import Sidebar from "./Sidebar";
import { Button } from "react-bootstrap";
import VendorAdvanceForm from "../Components/VendorAdvanceForm";
import Modal from "../Components/Modal";
import Footer from "../Components/Footer";

const VendorAdvance = ({ handleLogout }) => {
  const [advanceForm, setAdvanceForm] = useState({
    date: new Date().toISOString().split("T")[0],
    vendor_id: "",
    amount: "",
    remarks: "",
    type: "Normal",
    status: "open",
  });
  const [showForm, setShowForm] = useState(false);
  const [advance, setAdvance] = useState([]);
  const [vendors, setVendors] = useState([]);
  const toast = useToast();
  const [showSideBar, setShowSideBar] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    fetchAdvances();
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const res = await getAllVendors();
      setVendors(res.data);
    } catch (err) {
      toast(err.message || "Failed to fetch vendors", "ERROR");
    }
  };

  const fetchAdvances = async () => {
    try {
      const res = await getAllAdvance();
      const advances = Array.isArray(res.data) ? res.data : [];

      const enriched = await Promise.all(
        advances.map(async (adv) => {
          try {
            const response = await getPaymentHistoryByAdvance(adv.id);
            console.log("res", response);

            const payment = response.data || [];

            const totalDeduction = payment.reduce((sum, p) => {
              if (adv.type === "Normal") {
                return sum + Number(p.nor_advance_deduction || 0);
              } else if (adv.type === "Receipt") {
                return sum + Number(p.res_advance_deduction || 0);
              }
              return sum;
            }, 0);

            return {
              ...adv,
              total_deduction: totalDeduction,
              balance_amount: Number(adv.amount || 0) - totalDeduction,
            };
          } catch (err) {
            return {
              ...adv,
              total_deduction: 0,
              balance_amount: Number(adv.amount || 0),
            };
          }
        })
      );

      const sortedAdvances = enriched.sort((a, b) => b.id - a.id);
      setAdvance(sortedAdvances);
    } catch (err) {
      toast(err.message || "Failed to fetch advances", "ERROR");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdvanceForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleCancel = () => {
    setAdvanceForm({
      date: new Date().toISOString().split("T")[0],
      vendor_id: "",
      amount: "",
      remarks: "",
      type: "Normal",
      status: "open",
    });
    setShowForm(false);
  };

  const handleKeyDown = (e, nextFieldName) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
    const nextInput =
      document.querySelector(`input[name="${nextFieldName}"]`) ||
      document.querySelector(`input[type="radio"][name="${nextFieldName}"]`);
    if (nextInput) {
      nextInput.focus();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !advanceForm.date ||
      !advanceForm.vendor_id ||
      !advanceForm.amount ||
      !advanceForm.remarks
    ) {
      toast("Please fill all fields");
      return;
    }

    try {
      await saveAdvance(advanceForm);
      toast(
        advanceForm.id
          ? "Advance updated successfully"
          : "Advance added successfully",
        "SUCCESS"
      );
      fetchAdvances();
      handleCancel();
    } catch (err) {
      toast(err.message || "Failed to save advance", "ERROR");
    }
  };

  return (
    <div className="fixed-bottom-bar" style={{ backgroundColor: " #F0F8FF" }}>
      <div className="osahan-trending">
        {/* Header */}
        <div className="bg-primary border-bottom p-3">
          <div className=" d-flex align-items-center justify-content-between">
            <Link to="/" className="text-white font-weight-bold">
              <ChevronLeft /> Back
            </Link>
            <Link className="toggle">
              <span
                className="toggle"
                onClick={() => setShowSideBar(true)}
                style={{ cursor: "pointer" }}
              >
                <Menu size={30} color="white" />
              </span>
            </Link>
          </div>
          <h2 className="font-weight-bold pt-3 m-0 text-white">
            Vendor Advance
          </h2>
        </div>

        <div className="d-flex justify-content-end mt-3 px-3 ">
          <Button
            variant="secondary"
            size="sm"
            style={{ outline: "none", border: "none" }}
            onClick={() => setShowForm(true)}
          >
            Add
          </Button>
        </div>

        <Modal
          visible={showForm}
          size="sm"
          onClose={handleCancel}
          headerText={"Add VendorAdvance"}
          dialdialogClassName="custom-modal"
        >
          <VendorAdvanceForm
            advanceForm={advanceForm}
            vendors={vendors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
            setVendors={vendors}
            setAdvanceForm={setAdvanceForm}
            handleKeyDown={handleKeyDown}
          />
        </Modal>

        {/* Trending Cards */}
        <div className="most_popular p-3">
          <div className="row justify-content-center">
            {advance.map((adv) => {
              const vendorName = vendors.find((v) => v.id === adv.vendor_id);

              return (
                <div
                  className="col-12 d-flex justify-content-center mb-3"
                  key={adv.id}
                >
                  <div className=" cards">
                    <div className="card-body">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0 font-weight-bold text-capitalize">
                          {vendorName?.name}
                        </h6>

                        <span
                          className={`status-badge badge ${
                            adv.status === "open"
                              ? "badge-success"
                              : "badge-secondary"
                          }`}
                        >
                          {adv.status}
                        </span>
                      </div>

                      {/* Details */}
                      <div className="row text-muted">
                        <div className="col-6 mb-2">
                          <strong>Type:</strong>
                          <p style={{ color: "black" }}>{adv.type}</p>
                        </div>

                        <div className="col-6 mb-2">
                          <strong>Amount:</strong>
                          <p style={{ color: "black" }}>
                            ₹ {adv.amount.toFixed(2)}
                          </p>
                        </div>

                        <div className="col-6 mb-2">
                          <strong>Deducted:</strong>
                          <p style={{ color: "black" }}>
                            ₹ {adv.total_deduction.toFixed(2)}
                          </p>
                        </div>

                        <div className="col-6 mb-2">
                          <strong>Balance:</strong>
                          <div className="text-danger font-weight-bold">
                            ₹ {adv.balance_amount.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Sidebar */}
        <Sidebar
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          onLogout={handleLogout}
        />

        {/* Footer */}
            <Footer />
      </div>
    </div>
  );
};

export default VendorAdvance;
